import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Iconify from '../../../reusable-components/iconify';
import { useScopeCheck } from '../../../reusable-components/scopes';

export default function CustomToolbar() {
  const isAdmin = useScopeCheck(['Transition-Admin'], false, true);
  const navigate = useNavigate();
  const addNewPortfolio = () => navigate('/dashboard/transitions/initial-due-diligence');

  return (
    <Box sx={{ display: 'flex', mt: 1 }} gap={1}>
      {isAdmin && (
        <Button
          onClick={addNewPortfolio}
          sx={{ padding: '3px 10px' }}
          variant="outlined"
          color="secondary"
          startIcon={<Iconify icon="eva:plus-outline" />}
        >
          New Portfolio
        </Button>
      )}
      <Button
        sx={{ padding: '3px 10px' }}
        variant="outlined"
        color="secondary"
        startIcon={<Iconify icon="file-icons:microsoft-excel" />}
      >
        Download
      </Button>
    </Box>
  );
}
